import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Vallalar Velai Vaaipu Sevai Iyakkam - Free Job Portal",
  description = "VVVSI - India's trusted free job portal connecting job seekers with employers. Find jobs, post vacancies, and build your career with Vallalar Velai Vaaipu Sevai Iyakkam.",
  keywords = "jobs, job portal, employment, career, recruitment, VVVSI, Vallalar, free jobs, India jobs, job search, employer, job seeker",
  image = "/vvvsi-og-image.jpg",
  url = "",
  type = "website"
}) => {
  const siteUrl = window.location.origin;
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Vallalar Velai Vaaipu Sevai Iyakkam" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="VVVSI Job Portal" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Additional SEO */}
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
    </Helmet>
  );
};

export default SEO;
